import React from 'react';
import styled from '@emotion/styled';
import { Text } from '../../common';

const NPSStyles = {
  inputContainer: styled.div`
    margin: 10px 0;
  `,
  labelContainer: styled.div`
    padding-left: 5px;
    padding-bottom: 10px;
  `,
  container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  scaleContainer: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
    padding: 0 5px;
  `,
  scaleItem: styled.div`
    flex: 1;
    font-size: 11px;
    color: #666;
    ${props => (props.align === 'left' ? 'text-align: left;' : 'text-align: right;')}
  `,
  boxContainer: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 0 8px;
    gap: 1px;
  `,
  boxButton: styled.button`
    flex: 1;
    min-width: 26px;
    max-width: 34px;
    height: 30px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 2px solid ${props => props.color};
    background-color: ${props => props.color};
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
    font-size: 12px;
    transition: all 0.2s ease;
    box-shadow: ${props => (props.isSelected ? `0 0 0 2px #fff, 0 0 0 4px ${props.color}` : 'none')};
    transform: ${props => (props.isSelected ? 'scale(1.12)' : 'none')};
    z-index: ${props => (props.isSelected ? 1 : 0)};
    &:hover { opacity: 0.9; }
  `
};

const NPS_START_COLOR = 'rgb(209,70,27)';
const NPS_MIDDLE_COLOR = 'rgb(128,128,128)';
const NPS_END_COLOR = 'rgb(36,98,162)';

const getNpsColor = score => {
  if (score <= 6) return NPS_START_COLOR;
  if (score <= 8) return NPS_MIDDLE_COLOR;
  return NPS_END_COLOR;
};

const NPSQuestion = ({ label, value = null, onValueChange, scale, disabled = false }) => {
  return (
    <NPSStyles.inputContainer>
      {label && (
        <NPSStyles.labelContainer>
          <Text as="div" fontWeight="bold" color={disabled ? '#aaa' : '#666'}>
            {label}
          </Text>
        </NPSStyles.labelContainer>
      )}

      <NPSStyles.container>
        <NPSStyles.scaleContainer>
          <NPSStyles.scaleItem align="left" style={{ color: disabled ? '#aaa' : '#666' }}>
            {`0 = ${scale[0]}`}
          </NPSStyles.scaleItem>
          <NPSStyles.scaleItem align="right" style={{ color: disabled ? '#aaa' : '#666' }}>
            {`${scale.length - 1} = ${scale[scale.length - 1]}`}
          </NPSStyles.scaleItem>
        </NPSStyles.scaleContainer>

        <NPSStyles.boxContainer>
          {scale.map((_, index) => {
            const selectedIndex =
              value === null || value === undefined || value === '' ? null : Number(value);
            const isSelected =
              selectedIndex !== null && !Number.isNaN(selectedIndex) && index === selectedIndex;
            return (
              <NPSStyles.boxButton
                key={index}
                isSelected={isSelected}
                color={disabled ? '#ddd' : getNpsColor(index)}
                onClick={() => !disabled && onValueChange(index)}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
              >
                {index}
              </NPSStyles.boxButton>
            );
          })}
        </NPSStyles.boxContainer>
      </NPSStyles.container>
    </NPSStyles.inputContainer>
  );
};

export default NPSQuestion;
